import React from 'react';
import { Link } from 'react-router-dom';

const IconSparkles = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M12 3v3" />
    <path d="M12 18v3" />
    <path d="M3 12h3" />
    <path d="M18 12h3" />
    <path d="m5.6 5.6 2.1 2.1" />
    <path d="m16.3 16.3 2.1 2.1" />
    <path d="m5.6 18.4 2.1-2.1" />
    <path d="m16.3 7.7 2.1-2.1" />
  </svg>
);

const IconUsers = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
  </svg>
);

const IconTag = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" />
  </svg>
);

const IconCog = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h0a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const AdminShortcutCard: React.FC = () => {
  return (
    <section className="dash-admin" aria-labelledby="dash-admin-title">
      <div className="dash-admin-head">
        <h2 className="dash-admin-title" id="dash-admin-title">
          <IconSparkles />
          Acces administrator
        </h2>
        <span className="dash-admin-sub">Doar pentru tine</span>
      </div>
      <div className="dash-admin-grid">
        <Link to="/admin/users" className="dash-admin-link">
          <span className="dash-admin-link-icon" aria-hidden>
            <IconUsers />
          </span>
          <span className="dash-admin-link-body">
            <span className="dash-admin-link-title">Utilizatori</span>
            <span className="dash-admin-link-hint">Conturi, roluri și acces</span>
          </span>
        </Link>
        <Link to="/admin/classifications" className="dash-admin-link">
          <span className="dash-admin-link-icon" aria-hidden>
            <IconTag />
          </span>
          <span className="dash-admin-link-body">
            <span className="dash-admin-link-title">Clasificări</span>
            <span className="dash-admin-link-hint">Taxonomii pentru documente</span>
          </span>
        </Link>
        <Link to="/admin/system" className="dash-admin-link">
          <span className="dash-admin-link-icon" aria-hidden>
            <IconCog />
          </span>
          <span className="dash-admin-link-body">
            <span className="dash-admin-link-title">Sistem</span>
            <span className="dash-admin-link-hint">Prompturi, mapări, pipeline</span>
          </span>
        </Link>
      </div>
    </section>
  );
};

export default AdminShortcutCard;
